import React from 'react';
import PropTypes from 'prop-types';
import {FormattedDate, FormattedMessage, FormattedTime} from "react-intl";
import {Avatar, Stack} from "@mui/material";
import {styled} from "@mui/material/styles";

import {black500, green500, greyishBlue400} from "assets/jss/main";

DecisionAuthor.propTypes = {
    name: PropTypes.string,
    decidedAt: PropTypes.string,
};

const Name = styled('span')({
    color: black500,
    fontSize: '14px',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

const Caption = styled('span')({
    color: greyishBlue400,
    fontSize: '12px',
});

function initials(name) {
    return name.split(' ').filter(Boolean).slice(0, 2).map((part) => part[0].toUpperCase()).join('');
}

function DecisionAuthor({name, decidedAt}) {
    return (
        <Stack gap="8px" sx={{width: '176px'}}>
            <Stack direction="row" alignItems="center" gap="8px" sx={{minWidth: 0}}>
                <Avatar sx={{width: 32, height: 32, bgcolor: green500, fontSize: '14px', fontWeight: 600}}>
                    {name ? initials(name) : 'IA'}
                </Avatar>
                <Name title={name ?? undefined}>
                    {name ?? <FormattedMessage id="enrichment.decision.automatic"/>}
                </Name>
            </Stack>
            {decidedAt && (
                <Caption>
                    <FormattedMessage
                        id="enrichment.decision.date"
                        values={{
                            date: <FormattedDate value={decidedAt} day="2-digit" month="2-digit" year="numeric"/>,
                            time: <FormattedTime value={decidedAt} hour="2-digit" minute="2-digit"/>,
                        }}
                    />
                </Caption>
            )}
        </Stack>
    );
}

export default DecisionAuthor;
